import stores from "@/stores"

// 离开页面时，确认是否离开
export async function showConfirmModalBeforeLeave() {
  return new Promise<boolean>((resolve) => {
    stores.CommonStore.setConfirmModalConfig({
      title: t("DiscardChanges"),
      message: t("AreYouSureYouWantToDiscardAllUns"),
      onConfirm: function () {
        resolve(true)
      },
      onCancel() {
        resolve(false)
      },
      extraPrimaryAction: {
        content: t("Discard"),
        destructive: true,
      },
      extraCancelAction: {
        content: t("ContinueEditing"),
      },
    })
  })
}
